import React from 'react';
import { Link } from 'react-router';

class MobileMenu extends React.Component {

	render() {

		return (
			<div className="mobile-menu-wrapper">

				<ul className="mobile-menu-list">
					<li className="mobile-menu-list-item">
						<Link to="/route-planning" className="mobile-menu-link" onClick={ this.props.toggleMenu }>
							<svg className="icon left-icon"><use xlinkHref="#route-planner" /></svg>
							Route Planner
							<svg className="icon" aria-hidden="true"><use xlinkHref="#arrow_carrot-right" /></svg>
						</Link>
					</li>

					<li className="mobile-menu-list-item">
						<Link to="/leisure-rides" className="mobile-menu-link" onClick={ this.props.toggleMenu }>
							<svg className="icon left-icon"><use xlinkHref="#leisure-ride" /></svg>
							Leisure Rides
							<svg className="icon" aria-hidden="true"><use xlinkHref="#arrow_carrot-right" /></svg>
						</Link>
					</li>

					<li className="mobile-menu-list-item">
						<Link to="/cycle-routes" className="mobile-menu-link" onClick={ this.props.toggleMenu }>
							<svg className="icon left-icon"><use xlinkHref="#cycling-route" /></svg>
							Cycle Routes
							<svg className="icon" aria-hidden="true"><use xlinkHref="#arrow_carrot-right" /></svg>
						</Link>
					</li>

					<li className="mobile-menu-list-item">
						<Link to="/cycle-hire" className="mobile-menu-link" onClick={ this.props.toggleMenu }>
							<svg className="icon left-icon"><use xlinkHref="#bike-rentals" /></svg>
							Bike Shops & Rentals
							<svg className="icon" aria-hidden="true"><use xlinkHref="#arrow_carrot-right" /></svg>
						</Link>
					</li>

					<li className="mobile-menu-list-item">
						<Link to="/public-pumps" className="mobile-menu-link" onClick={ this.props.toggleMenu }>
							<svg className="icon left-icon"><use xlinkHref="#pump-white" /></svg>
							Public Bike Pumps
							<svg className="icon" aria-hidden="true"><use xlinkHref="#arrow_carrot-right" /></svg>
						</Link>
					</li>

					<li className="mobile-menu-list-item">
						<Link to="/explore-map" className="mobile-menu-link" onClick={ this.props.toggleMenu }>
							<svg className="icon left-icon"><use xlinkHref="#explore_map" /></svg>
							Explore Map
							<svg className="icon" aria-hidden="true"><use xlinkHref="#arrow_carrot-right" /></svg>
						</Link>
					</li>
				</ul>

			</div>
		)
	}
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/MobileMenu.js